'use client'

import { useEffect, useState } from "react";
import React from 'react';
import BackBtn from '../svg/back-btn';
import Link from "next/link"
import BackBtnMob from '../svg/back-btn-mob';

interface TitleProps {
    text: string;
    position: 'center' | 'left' | 'right';
    color?: string; 
    fontSize?: string; 
    lineHeight?: string;
    backBtn?: string; 
    backUrl?: string; 
}

const Title: React.FC<TitleProps> = ({
    text,
    position,
    color = "text-black-50",
    fontSize = "text-[48px]",
    lineHeight = "leading-[121%]",
    backBtn = "no",
    backUrl = "#", 
}) => {
    const alignmentClass = 
        position === 'center' ? 'flex justify-center text-center' :
        position === 'left' ? 'flex justify-start' :
        position === 'right' ? 'flex justify-end text-right' : '';

    const textColorClass = color; 
    const textSize = fontSize; 
    const textHeight = lineHeight;

    const [backIcon, setbackIcon] = useState(<BackBtn />);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 992) {
                setbackIcon(<BackBtnMob />);
            } else {
                setbackIcon(<BackBtn />);
            }
        };
    
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className={`${alignmentClass} relative`}>
            {backBtn === "yes" && (
                <div className="flex items-center absolute left-[-72px] max-[1500px]:left-[-50px] top-[50%] translate-y-[-50%]">
                    <Link href={`/${backUrl}`} className="">
                        {backIcon}
                    </Link>
                </div>
            )}
            <h2
                className={`max-w-[735px] font-bold mb-[0] max-[767px]:text-[24px] max-[992px]:text-[24px] ${textColorClass + ' ' + textSize + ' ' + textHeight}`}
                dangerouslySetInnerHTML={{ __html: text }}
            />
        </div>
    );
};

export default Title;
